export type PhoneGateUser = {
  authProvider?: string | null;
  phone?: string | null;
  phoneVerified?: boolean | null;
};

/** Google accounts must have a verified phone before Home. */
export function needsGooglePhoneGate(user?: PhoneGateUser | null): boolean {
  if (!user) return false;
  if (String(user.authProvider || "").toUpperCase() !== "GOOGLE") return false;
  if (!user.phone) return true;
  return user.phoneVerified !== true;
}
